import {
  SET_UPLOAD_FILE_ERROR,
  SET_UPLOAD_FILE_RESULTS
} from 'state/uploadFile/UploadFileActions';
import {
  INCREASE_STEP,
  DECREASE_STEP
} from 'state/steps/StepActions';

export const setUploadFileResultsReducer = (state=false, action) => {
  const { type, payload } = action;
  switch (type){
  case SET_UPLOAD_FILE_RESULTS:
  {
    return {
      ...state,
      results: payload,
      error: {}
    };
  }
  case SET_UPLOAD_FILE_ERROR: 
  {
    return {
      ...state,
      results: {},
      error: payload
    };
  }
  case INCREASE_STEP:
    return null;
  case DECREASE_STEP:
    return null;
  default:
    return state;
  }
}